(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sozu-brand-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sozu-brand-story')) {
    customElements.define('sozu-brand-story', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('.sozu-brand-story__video');
        this.button = this.querySelector('.sozu-brand-story__play');
        this.label = this.querySelector('.sozu-brand-story__play-label');
        this.status = this.querySelector('.sozu-brand-story__status');
        if (!this.video || !this.button) return;
        if (this.abort) this.abort.abort();
        this.abort = new AbortController();
        this.userPaused = false;
        this.automaticPauseEvents = 0;
        this.mobile = window.matchMedia('(max-width: 749px)');
        this.sourceRequest = 0;
        this.selectedUrl = '';
        this.visible = !('IntersectionObserver' in window);
        this.pendingTime = null;
        this.video.muted = true;
        this.video.defaultMuted = true;
        this.video.loop = true;
        const options = { signal: this.abort.signal };
        const update = () => {
          const audible = !this.video.muted && this.video.volume > 0;
          this.button.hidden = !this.video.paused && audible;
          this.label.textContent = audible ? this.dataset.playLabel : this.dataset.soundOnLabel;
        };
        this.updatePlayback = update;
        this.button.hidden = false;
        this.button.addEventListener('click', () => {
          this.status.textContent = '';
          this.userPaused = false;
          this.video.muted = false;
          if (this.video.volume === 0) this.video.volume = 1;
          if (this.video.ended) this.video.currentTime = 0;
          this.start();
        }, options);
        this.video.addEventListener('play', () => {
          this.userPaused = false;
          this.video.autoplay = true;
          if (document.hidden) {
            this.pauseForVisibility();
            return;
          }
          document.querySelectorAll('sozu-brand-story .sozu-brand-story__video').forEach(other => {
            if (other !== this.video) other.pause();
          });
          this.status.textContent = '';
          update();
        }, options);
        this.video.addEventListener('pause', () => {
          if (this.automaticPauseEvents > 0) this.automaticPauseEvents -= 1;
          else if (!document.hidden) {
            this.userPaused = true;
            this.video.autoplay = false;
          }
          update();
        }, options);
        this.video.addEventListener('playing', update, options);
        this.video.addEventListener('volumechange', update, options);
        this.video.addEventListener('ended', update, options);
        this.video.addEventListener('error', () => {
          this.status.textContent = this.dataset.errorLabel;
          update();
        }, options);
        this.mobile.addEventListener('change', () => {
          if (this.visible) {
            this.selectSource();
            this.start();
          }
        }, options);
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.pauseForVisibility();
          else if (this.visible) {
            this.selectSource();
            this.start();
          }
        }, options);
        update();
        if ('IntersectionObserver' in window) {
          this.observer?.disconnect();
          this.observer = new IntersectionObserver(entries => {
            this.visible = entries[0].isIntersecting && entries[0].intersectionRatio >= .1;
            if (this.visible) {
              this.selectSource();
              this.start();
            } else {
              this.pauseForVisibility();
            }
          }, { threshold: .1 });
          this.observer.observe(this);
        } else {
          this.selectSource();
          this.start();
        }
      }
      selectSource() {
        const useMobile = this.mobile.matches && !!this.video.dataset.mobileSrc;
        const url = useMobile ? this.video.dataset.mobileSrc : (this.video.dataset.desktopSrc || this.video.dataset.mobileSrc);
        const poster = useMobile ? (this.video.dataset.mobilePoster || this.video.dataset.desktopPoster) : this.video.dataset.desktopPoster;
        if (poster) this.video.poster = poster;
        else this.video.removeAttribute('poster');
        if (!url || url === this.selectedUrl) return;
        const time = this.pendingTime === null ? this.video.currentTime : this.pendingTime;
        const muted = this.video.muted;
        const volume = this.video.volume;
        this.pauseForVisibility();
        const request = ++this.sourceRequest;
        this.selectedUrl = url;
        this.pendingTime = Number.isFinite(time) ? time : 0;
        this.video.autoplay = !this.userPaused && !document.hidden;
        this.video.addEventListener('loadedmetadata', () => {
          if (request !== this.sourceRequest) return;
          const duration = this.video.duration;
          const time = Number.isFinite(duration) ? Math.min(this.pendingTime || 0, Math.max(0, duration - .05)) : (this.pendingTime || 0);
          if (time > 0) this.video.currentTime = time;
          this.pendingTime = null;
          this.updatePlayback();
          this.start();
        }, { once: true, signal: this.abort.signal });
        this.video.muted = muted;
        this.video.volume = volume;
        this.video.src = url;
        this.video.load();
      }
      start() {
        if (!this.visible || document.hidden || this.userPaused || !this.selectedUrl || this.pendingTime > 0) return;
        this.video.autoplay = true;
        const request = this.sourceRequest;
        const promise = this.video.play();
        if (promise) promise.catch(() => {
          if (request !== this.sourceRequest || !this.isConnected) return;
          this.status.textContent = this.dataset.errorLabel;
          this.updatePlayback();
        });
      }
      pauseForVisibility() {
        this.video.autoplay = false;
        if (!this.video.paused) {
          this.automaticPauseEvents += 1;
          this.video.pause();
        }
      }
      disconnectedCallback() {
        if (this.abort) this.abort.abort();
        if (this.observer) this.observer.disconnect();
        this.sourceRequest += 1;
        if (this.video) this.video.pause();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sozu-cinematic-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sozu-cinematic-hero')) {
    customElements.define('sozu-cinematic-hero', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        this.video = this.querySelector('video');
        this.button = this.querySelector('.sozu-hero__motion');
        this.label = this.querySelector('.sozu-hero__motion-label');
        this.mobile = window.matchMedia('(max-width: 749px)');
        this.visible = true;
        this.userPaused = false;
        this.sourceUrl = '';
        this.playRequest = 0;
        this.video.muted = true;
        this.video.defaultMuted = true;
        const options = { signal: this.abort.signal };
        this.video.addEventListener('playing', () => {
          this.classList.add('is-ready');
          this.updateButton();
        }, options);
        this.video.addEventListener('pause', () => this.updateButton(), options);
        this.video.addEventListener('error', () => {
          if (this.video.getAttribute('src') === this.sourceUrl) this.showPoster();
        }, options);
        this.button.addEventListener('click', () => {
          if (this.video.paused) {
            this.userPaused = false;
            this.start();
          } else {
            this.userPaused = true;
            this.video.pause();
          }
        }, options);
        this.mobile.addEventListener('change', () => {
          this.release();
          this.selectSource();
          this.start();
        }, options);
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.video.pause();
          else this.start();
        }, options);
        this.selectSource();
        this.start();
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            this.visible = entries[0].isIntersecting;
            if (this.visible) this.start();
            else this.video.pause();
          }, { threshold: .1 });
          this.observer.observe(this);
        }
      }
      selectSource() {
        const template = this.querySelector(this.mobile.matches ? '[data-sozu-mobile]' : '[data-sozu-desktop]');
        const sources = Array.from(template.content.querySelectorAll('source[data-src]'));
        const limit = this.mobile.matches ? 1080 : 1920;
        sources.sort((a, b) => Number(a.dataset.width) - Number(b.dataset.width));
        const eligible = sources.filter(source => Number(source.dataset.width) <= limit);
        const selected = eligible[eligible.length - 1] || sources[0];
        this.sourceUrl = selected ? selected.dataset.src : '';
        this.button.hidden = !this.sourceUrl;
        this.updateButton();
      }
      start() {
        if (!this.sourceUrl || !this.visible || document.hidden || this.userPaused) return;
        if (!this.video.getAttribute('src')) {
          this.video.src = this.sourceUrl;
          this.video.load();
        }
        const request = ++this.playRequest;
        const promise = this.video.play();
        if (promise) promise.catch(() => {
          if (request === this.playRequest && this.isConnected) this.showPoster();
        });
      }
      updateButton() {
        const playing = !this.video.paused;
        const label = playing ? this.dataset.pauseLabel : this.dataset.playLabel;
        this.classList.toggle('is-playing', playing);
        this.button.setAttribute('aria-label', label);
        this.label.textContent = label;
      }
      showPoster() {
        this.video.pause();
        this.classList.remove('is-ready');
        this.updateButton();
      }
      release() {
        this.playRequest += 1;
        this.video.pause();
        this.video.removeAttribute('src');
        this.video.load();
        this.classList.remove('is-ready', 'is-playing');
      }
      disconnectedCallback() {
        if (this.abort) this.abort.abort();
        if (this.observer) this.observer.disconnect();
        if (this.video) this.release();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
